import { createReportTransport } from 'shared/api/reportTransport';
import type { ReportFile } from './types';
export { reportPath, errorText } from 'shared/api/reportTransport';

const { client, api: transport } = createReportTransport('/api');
export const api = {
  ...transport,
  upload: async (reportId:string, fileId:string, file:File, progress:(percent:number)=>void):Promise<ReportFile> => {
    const payload = new FormData(); payload.append('fileId',fileId); payload.append('file',file);
    return (await client.post<ReportFile>('/reports/'+reportId+'/files',payload, {
      onUploadProgress:event=>progress(event.total ? Math.min(99,Math.round(100*event.loaded/event.total)) : 0),
    })).data;
  },
};
export const REPORT_ASSETS_CHANGED = 'unity-report-assets-changed';
export const notifyReportAssetsChanged = (reportId: string, assetId?: string) =>
  window.dispatchEvent(new CustomEvent(REPORT_ASSETS_CHANGED, {detail:{reportId,assetId}}));
